enum SetAutoGeneratedPlaceIconErrorCodes {
  UnknownError = 0, // Unknown Error.
  InvalidUniverse = 2, // The universe does not exist.
  NoRootPlace = 3, // This universe does not have a root place.
  UpdatedTooOften = 5, // You can only submit 12 auto generated icons to moderation every 24 hours.
}

export default SetAutoGeneratedPlaceIconErrorCodes;
